import { useTranslation } from 'react-i18next'
import { Row, StyledContainer } from './utils'

export const NotificationsSwitch = (props: any) => {
    const { t } = useTranslation()

    const { active, handleUpdate, loading } = props

    return (
        <StyledContainer data-ai-explain="Master switch: receive email notifications for this app">
            <Row
                active={active}
                label={t('ReceiveEmailNotifications')}
                description={t('EnableDisableNotifications')}
                onChange={handleUpdate}
                loading={loading}
            />
        </StyledContainer>
    )
}
